import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getBranchList = params => {
  return axios.request({
    url: `/doubleClearance/batchInfo`,
    method: "get",
    params
  });
};

export const saveBranchFeright = data => {
  return axios.request({
    url: `/doubleClearance/batchSave`,
    method: "post",
    data
  });
};
